import Cookies from 'js-cookie';

const createCookie = (name, value, conf = {}, replace = true) => {
  if (replace) {
    Cookies.set(name, value, conf);
  } else {
    if (!Cookies.get(name)) {
      Cookies.set(name, value, conf);
    }
  }
};

const getCookie = name => {
  return Cookies.get(name);
};

const removeCookie = name => {
  Cookies.remove(name);
};

export { createCookie, removeCookie, getCookie };
